import Vue from 'vue';

interface FormField {
	label: string;
	value: any;
}

interface Form {
	username: FormField;
	apartment: FormField;
	phone: FormField;
	email: FormField;
}

export default Vue.extend({
	data () {
		return {
			dialog_crew: false,
			crew_in_dialog: false,
			check: ['white'],

			ca_tabs1_1: null,
			ca_tabs1_2: null,
			ca_tabs1_3: null,
			ca_tabs1_4: null,
			ca_tabs2_1: null,
			ca_tabs2_2: null,
			ca_tabs3_1: null,
			ca_tabs3_2: null,
			ca_tabs3_3: null,
			form: {
				username: { label: "", value: null },
				apartment: { label: "", value: null },
				phone: { label: "", value: null },
				email: { label: "", value: null },
			} as Form
		}
	},

	created() {
		this.updateFormLabels();
	},

	watch: {
		// 언어가 변경될 때마다 폼 라벨을 업데이트합니다.
		'$i18n.locale'() {
			this.updateFormLabels();
		}
	},

	methods:
		{
			updateFormLabels() {
				this.form.username.label = this.$t('ServicePages.CrewAdvantage.form.name') as string;
				this.form.apartment.label = this.$t('ServicePages.CrewAdvantage.form.company') as string;
				this.form.phone.label = this.$t('ServicePages.CrewAdvantage.form.phone') as string;
				this.form.email.label = this.$t('ServicePages.CrewAdvantage.form.email') as string;
			},

			HANDLE_SEND_SLACK() {
				if (!this.isPrivacyAgreed()) return;
				if (!this.areRequiredFieldsFilled()) return;

				const type = this.$t('ServicePages.CrewAdvantage.slack.manualRequestType') as string;
				const content = this.createContentMessage(type);
				this.sendSlackMessage(content);
			},

			isPrivacyAgreed(): boolean {
				if (this.check.length < 2) {
					this.$toasted.show(this.$t('ServicePages.CrewAdvantage.toasts.agreePrivacy') as string);
					return false;
				}
				return true;
			},

			areRequiredFieldsFilled(): boolean {
				const requiredFields: (keyof Form)[] = ['username', 'apartment', 'email'];
				for (const key of requiredFields) {
					if (this.form[key].value === null) {
						this.$toasted.show(this.$t('ServicePages.CrewAdvantage.toasts.fillField', { field: this.form[key].label }) as string);
						return false;
					}
				}
				return true;
			},

			createContentMessage(type: string): string {
				const title = this.$t('ServicePages.CrewAdvantage.slack.requestMessageTitle', { type: type });
				const contentArr = [title];

				Object.keys(this.form).forEach(key => {
					const typedKey = key as keyof Form;
					const value = this.form[typedKey].value;
					const label = this.form[typedKey].label;

					contentArr.push(this._.sprintf("%s: %s", [label, value]));
				});

				return contentArr.join('\n');
			},

			resetFormValues() {
				Object.keys(this.form).forEach(key => {
					const typedKey = key as keyof Form;
					this.form[typedKey].value = null;
				});
				this.check = ['white'];
			},

			sendSlackMessage(content: string) {
				this.$aws.lambda.invoke(
					process.env.VUE_APP_AWS_LAMBDA_CREATE_MESSAGE_SLACK as string,
					'RequestResponse',
					JSON.stringify({
						action: 'OFFICIAL',
						content: content
					})
				).then( res => {
					this.resetFormValues();
					this.crew_in_dialog = true;
				});
			}
		},
	computed:
		{
			usePrivacy() {
				return process.env.VUE_APP_PRIVACY;
			}
		}
});